import { useCallback, useEffect } from 'react';

export const useUnsavedChanges = (isDirty) => {
  useEffect(() => {
    if (!isDirty) return undefined;
    const warnBeforeUnload = event => {
      event.preventDefault();
      event.returnValue = '';
    };
    window.addEventListener('beforeunload', warnBeforeUnload);
    return () => window.removeEventListener('beforeunload', warnBeforeUnload);
  }, [isDirty]);

  return useCallback(
    () => !isDirty || window.confirm('You have unsaved changes. Discard them?'),
    [isDirty]
  );
};
